<template>
  <div class="logistics-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <!-- <el-form-item label="物流单号">
          <el-input
            v-model="filterForm.code"
            placeholder="请输入物流单号"
            clearable
          />
        </el-form-item> -->
        <el-form-item label="订单号">
          <el-input
            v-model="filterForm.orderDh"
            placeholder="请输入订单号"
            clearable
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable>
            <el-option label="待发货" :value="0" />
            <el-option label="已取消" :value="1" />
            <el-option label="已发货" :value="2" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 物流列表表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="logisticsList"
        height="56vh"
        border
        stripe
        @row-click="handleViewDetail"
        style="width: 100%"
      >
        <el-table-column prop="code" label="物流单号" min-width="160" show-overflow-tooltip />
        <el-table-column prop="orderDh" label="订单号" min-width="180" show-overflow-tooltip />
        <!-- <el-table-column prop="brandName" label="店铺名称" min-width="150" />
        <el-table-column prop="jxName" label="经销商" min-width="120" /> -->
        <el-table-column prop="goodsName" label="商品名称" min-width="200" show-overflow-tooltip />
        <el-table-column prop="quantity" label="发货数量" width="100" align="center" />
        <!-- <el-table-column prop="totalQty" label="订单总数量" width="110" align="center" /> -->
        <el-table-column prop="statusText" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'warning' : 'success'" size="small">
              {{ scope.row.statusText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column label="操作" width="100" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.stop="handleViewDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 详情弹窗 -->
    <el-dialog title="物流详情" :visible.sync="dialogVisible" width="65%" top="5vh">
      <el-descriptions :column="2" border v-if="currentItem" class="detail-descriptions">
        <el-descriptions-item label="物流单号">{{ currentItem.code }}</el-descriptions-item>
        <el-descriptions-item label="订单号">{{ currentItem.orderDh }}</el-descriptions-item>
        <!-- <el-descriptions-item label="店铺">{{ currentItem.brandName }}</el-descriptions-item>
        <el-descriptions-item label="经销商">{{ currentItem.jxName }}</el-descriptions-item> -->
        <el-descriptions-item label="商品名称">{{ currentItem.goodsName }}</el-descriptions-item>
        <el-descriptions-item label="发货数量">{{ currentItem.quantity }}</el-descriptions-item>
        <!-- <el-descriptions-item label="订单总数量">{{ currentItem.totalQty }}</el-descriptions-item> -->
        <el-descriptions-item label="状态">
          <el-tag :type="currentItem.status === 0 ? 'warning' : 'success'">
            {{ currentItem.statusText }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentItem.createTime }}</el-descriptions-item>
        <!-- 如果接口返回更多字段可扩展 -->
      </el-descriptions>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'LogisticsList',
  data () {
    return {
      loading: false,
      logisticsList: [],
      filterForm: {
        shopId: '',
        orderDh: '',
        code: '',
        status: '',
        startTime: '',
        endTime: ''
      },
      dateRange: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      pages: 0,

      // 店铺列表（用于筛选下拉）
      shopList: [],

      // 详情弹窗
      dialogVisible: false,
      currentItem: null
    }
  },

  mounted () {
    // this.getShopList()
    this.getLogisticsList()
  },

  methods: {
    // async getShopList () {
    //   try {
    //     const jxId = localStorage.getItem('jx_id') || ''
    //     // 假设存在获取店铺列表的接口，若无则忽略或使用静态数据
    //     const res = await request.post('/shop/getList.php', { jx_id: jxId })
    //     if (res.code === 0) {
    //       this.shopList = res.data || []
    //     }
    //   } catch (error) {
    //     console.error('获取店铺列表失败', error)
    //   }
    // },

    // ---------- 获取物流列表 ----------
    async getLogisticsList () {
      this.loading = true
      try {
        const params = {
          sh_id: localStorage.getItem('sh_id'),
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.shopId) params.sh_id = this.filterForm.shopId
        if (this.filterForm.code) params.code = this.filterForm.code
        if (this.filterForm.orderDh) params.comlist_v1 = this.filterForm.orderDh
        if (this.filterForm.status !== '' && this.filterForm.status !== null) {
          params.status = this.filterForm.status
        }
        if (this.filterForm.startTime) params.start_time = this.filterForm.startTime
        if (this.filterForm.endTime) params.end_time = this.filterForm.endTime

        const response = await request.post('/logistics/wuliu_list.php', params)

        if (response.code === 0) {
          const rawData = response.data || []
          // 将每个主记录中的 mx_list 展开为独立行
          const flattened = []
          rawData.forEach(item => {
            const mxList = item.mx_list || []
            mxList.forEach(mx => {
              flattened.push({
                // 主记录信息
                id: item.id,
                orderId: item.order_id || item.orderId,
                orderDh: item.comlist_v1,
                brandName: item.brand_name || item.brandName,
                jxName: item.jx_name || item.jxName,
                createTime: item.comlist3,
                status: parseInt(mx.status) || 0,
                // 明细信息
                mxId: mx.id,
                goodsId: mx.goods_id,
                goodsName: mx.goods_name || mx.goodsName,
                code: mx.code,
                quantity: parseInt(mx.comlist_s2 || mx.quantity || 0),
                totalQty: parseInt(mx.total_qty || mx.totalQty || 0)
              })
            })
          })
          this.logisticsList = flattened.map(item => ({
            ...item,
            statusText: this.getStatusText(item.status)
          }))
          this.pages = response.pages || 0
          this.total = this.pages * this.pageSize
        } else if (response.code === 1001) {
          this.$message.error('请先登录')
          this.logisticsList = []
          this.total = 0
        } else {
          this.$message.error(response.msg || '获取物流列表失败')
          this.logisticsList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求物流列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.logisticsList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // 状态映射
    getStatusText (status) {
      const map = {
        0: '待发货',
        1: '已取消',
        2: '已发货'
      }
      return map[status] || '未知'
    },

    // ---------- 筛选、重置、分页 ----------
    handleSearch () {
      if (this.dateRange && this.dateRange.length === 2) {
        this.filterForm.startTime = this.dateRange[0]
        this.filterForm.endTime = this.dateRange[1]
      } else {
        this.filterForm.startTime = ''
        this.filterForm.endTime = ''
      }
      this.currentPage = 1
      this.getLogisticsList()
    },

    handleReset () {
      this.filterForm = {
        shopId: '',
        code: '',
        status: '',
        startTime: '',
        endTime: ''
      }
      this.dateRange = []
      this.currentPage = 1
      this.getLogisticsList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getLogisticsList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.getLogisticsList()
    },

    // ---------- 查看详情 ----------
    handleViewDetail (row) {
      this.currentItem = row
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.logistics-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .detail-descriptions {
    margin-bottom: 20px;
  }
}
</style>
